module.exports = __webpack_public_path__ + "6d162294d70cd12df5f0eb674e633ad4.png";